import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CrudService, CustomHttp, ConfigServerService } from '../../../../core';
import { Lead } from '../lead';

@Injectable({
    providedIn: 'root'
})
export class LeadCrudHttpService {
    resource = 'crm/lead';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Procura um único lead através do seu ID */
    find(id: number): Observable<Lead> {
        return this.crudService.find<Lead>(this.resource, id);
    }

    /** Carrega um único lead através do seu ID */
    load(id: number): Observable<Lead> {
        return this.crudService.load<Lead>(this.resource, id)
                    .pipe(
                        map(lead => {
                            // Classificações
                            lead?.classificacoes?.forEach(classificacao => {
                                // Setando que pode editar a classificação
                                classificacao.canEdit = true;
                            })

                            return lead;
                        })
                    );
    }

    /** Salva um lead */
    save(entity: Lead): Observable<Lead> {
        return this.customHttp.put<Lead>(this.pathApi, entity);
    }

    /** Exclui um lead através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
